import { SubNavConfigMap, SubRoutes } from "Components/Navigation/NavigationTypes";
import { NavConfigItem } from "Navigation";
import mapValues from 'lodash/mapValues';
import { CommitteeSubRoutes, OpenCommitteeSubRoutes } from "./SubRoutes";

type SubRoutesMapType = {
  [x: string]: SubRoutes;
};

export const SUBROUTES_MAP: SubRoutesMapType = {
  ["/CommitteesView"]:
    CommitteeSubRoutes,
  ["/OpenCommitteesView"]:
    OpenCommitteeSubRoutes,
};


export const mapSubroutesToNavConfigItems = (
  subRoutes: SubRoutes
): NavConfigItem[] => {
  return Object.entries(subRoutes)
    .filter(([, subRoute]) => !subRoute.hideInSidebar)
    .map(([subRouteName, subRoute]) => {
      return { ...subRoute, subRouteName, active: false };
    });
};

export const SUB_NAV_CONFIG_MAP: SubNavConfigMap = mapValues(
  SUBROUTES_MAP,
  (subRoutes) => mapSubroutesToNavConfigItems(subRoutes)
);
